<template>
  <el-container>
    <doc-menu @init="initMenu"></doc-menu>
    <el-main>
      <article v-if="content">
        <h4 class="title">{{content.title}}</h4>
        <div class="wangEditor-container">
          <div class="wangEditor-txt" v-html="content.content"></div>
        </div>
      </article>
    </el-main>
  </el-container>
</template>
<script>
  import axios from 'common/axios.js';
  import DocMenu from './doc-menu.vue';
  export default {
    name: 'api-document',
    data() {
      return {
        content: null,
        currentId: null
      }
    },
    components: {
      DocMenu
    },
    watch: {
      '$route.query'(query) {
        this.getDocContent(query);
      },
    },
    async created() {
    },
    methods: {
      initMenu(id) {
        this.getDocContent({lv3: id});
      },
      async getDocContent(query) {
        const {lv3, lv2, lv1} = query;
        const categoryId = lv3 || lv2 || lv1;
        if (this.currentId == categoryId) return;
        this.currentId = categoryId;
        const {data: {result}} = await axios.get('/v2/openapi/doc/getContentByCategoryId', {params: {categoryId}});
        if (result) {
          this.content = result.docContent || {};
          this.content.content = this.content.content.replace(/\/v2\/dist\/api\.html#!\/document/ig, '/v2/dist/api.html#/document');
        } else {
          this.content = {}
        }
      }
    }
  }
</script>